<template>
  <gl-transactions :txs="txs">
    <template #tx-header="{ id, time }">
      <router-link
        :to="{ name: 'Transaction', params: { id } }"
        class="text-truncate text-underline"
        >{{ id }}</router-link
      >
      ({{ dateFullUTC(time) }})
    </template>
    <template #tx-input="{ inputs }">
      <template v-if="inputs?.length">
        <div v-for="(input, index) in inputs" :key="index" class="text-truncate">
          <router-link :to="{ name: 'Address', params: { id: input.address } }" class="text-link">
            {{ input.name }}
          </router-link>
        </div>
      </template>
      <template v-else>
        Coinbase (newly generated coins)
      </template>
    </template>
    <template #tx-output="{ minted, outputs, type }">
      <table class="tableInCell">
        <template v-for="(output, index) in outputs" :key="index">
          <tr class="tableInCell__row">
            <td class="tableInCell__cell tableInCell__cell--title text-truncate">
              <router-link
                :to="{ name: 'Address', params: { id: output.address || 'NotFound' } }"
                class="text-link"
                :class="{ 'text-gray': output.locked || output.locktime > +new Date() }"
              >
                {{ output.name }}
              </router-link>
            </td>
            <td
              class="tableInCell__cell"
              :class="{ 'text-gray': output.locked || output.locktime > +new Date() }"
            >
              {{ output.value / 100000000 }} PLC
            </td>
            <td
              v-if="output.locktime"
              class="tableInCell__cell"
              :class="output.locked || output.locktime > +new Date() ? 'text-gray' : 'text-yellow'"
            >
              {{ unlockedDate(output.locktime) }}
            </td>
          </tr>
        </template>
        <tr v-if="type === 'minting'" class="tableInCell__row tableInCell__row--section">
          <td class="tableInCell__cell tableInCell__cell--title">Minted Coins</td>
          <td class="tableInCell__cell">{{ minted }} PLC</td>
        </tr>
      </table>
    </template>
    <template #tx-confirmation="{ confirmations }">
      <gl-status v-if="confirmations" variant="info" size="sm">
        {{ confirmations }} Confirmations
      </gl-status>
      <gl-status v-else variant="danger" size="sm">Unconfirmed transaction!</gl-status>
    </template>
  </gl-transactions>
</template>

<script>
import GlTransactions from '@gl/GlTransactions'
import GlStatus from '@gl/GlStatus'
import { format } from 'date-fns'
import { dateFormat } from '@/config'

export default {
  name: 'AddressTransactions',
  components: { GlStatus, GlTransactions },
  props: {
    txs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    unlockedDate(date) {
      return format(date, dateFormat)
    },
    dateFullUTC(time) {
      return new Date(time).toUTCString()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/tableInCell';
</style>
